import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { getListOrders } from '../modules/ECommerce/_redux/order/productsCrud';
import { USER_MODE } from '../data/userModeConstants';

export const usePendingOrders = ({ branchId } = {}) => {
  const user = useSelector(state => state.auth.user);
  const isCustomer = user?.mode === USER_MODE.CUSTOMER;

  return useQuery({
    queryKey: ['pendingOrders', isCustomer, branchId],
    queryFn: async () => {
      const res = await getListOrders(isCustomer, {
        branch: branchId
      });
      return res.data.order.length;
    },
    refetchOnWindowFocus: false,
    enabled: !!user,
    staleTime: 3 * 1000
  });
};
